import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactory, ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { TableauDto } from "../../../dto/GenApi.iNotPaie.Dto/TableauDto";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { TableauLigneDto } from "../../../dto/GenApi.iNotPaie.Dto/TableauLigneDto";
import { RubriqueDto } from "../../../dto/GenApi.iNotPaie.Dto/RubriqueDto";
import { TableauLigneDetailDto } from "../../../dto/GenApi.iNotPaie.Dto/TableauLigneDetailDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ParametresInstance } from "../../Controls/Parameters";
import { RoleConstants } from "../../Controls/EventConstants";

@Component
export default class ModalUpdateTableau extends Vue {
    public rubriques: RubriqueDto[] = [];
	public listeConventionCollectives: ParametreDto[] = [];
	public listeRegimes: ParametreDto[] = [];
	public lignes: any[] = [];
    public lastId = 0;
    public currentLigne: TableauLigneDto = { Id: 0, AutoJournalPaye: false, Details: [] };
    public dataReady = true;
    public canDeposer = false;
	public tableau: TableauDto = {
    	Id: 0,
    	DetailMensuel: false,
    	TotalAnnuel: false,
    	FinMois: false,
    	Lignes: [],
    	EstArchive: false
	};

	public codeDuplique?: string
	public dataModeleLocal?: any;
    public nomModeleLocal?: string;

    public activated(): void {
        this.canDeposer = ParametresInstance.userHasRole(RoleConstants.AdministrateurPST);
    }

    public deactivated(): void {
        this.canDeposer = false;
    }

    public Init(codeTypeTableau: string, idTableau?: number, estDuplication?: boolean): void {
        this.initConstantes();

        this.dataModeleLocal = undefined;
        this.nomModeleLocal = undefined;

        if (idTableau != undefined) {
    		this.getTableau(idTableau, estDuplication ?? false);
    	} else {
    		this.initNewTableau(codeTypeTableau);
        }
	}

	public getTableau(idTableau: number, estDuplication: boolean): void {
    	this.dataReady = false;
    	ServicesFactoryInstance.EditionsService.getTableau(idTableau, data => {
            this.tableau = data;
            this.addLigne();
            this.setCurrentLigne(this.tableau.Lignes[0]);

            if (estDuplication) {
                this.codeDuplique = data.Code;

    			this.tableau.Code = "";
    			this.tableau.Id = 0;
    			this.tableau.EstArchive = false;
    		}
    		this.dataReady = true;
    	}, () => {
    		this.dataReady = true;
    	});
	}

	public initNewTableau(codeTypeTableau: string): void {
    	this.tableau = {
    		Id: 0,
    		DetailMensuel: false,
    		TotalAnnuel: false,
    		FinMois: false,
    		Lignes: [],
    		CodeTypeTableau: codeTypeTableau,
    		EstArchive: false
        };
        this.addLigne();
        this.setCurrentLigne(this.tableau.Lignes[0]);
	}

	public insertLine(): void {
    	const sequencesWhereInsert = this.currentLigne.Details.filter(s => (s as any).selected == true);
        if (sequencesWhereInsert.length == 0) {
            this.currentLigne.Details.push({});
    	} else {
    		// Insert the line
    		this.currentLigne.Details.splice(this.currentLigne.Details.indexOf(sequencesWhereInsert[sequencesWhereInsert.length - 1]) + 1, 0, {});
    	}
	}

	public moveLines(direction: string): void {
    	const sequencesABouger = this.currentLigne.Details.filter(s => (s as any).selected == true);
    	if (sequencesABouger.length == 0) {
    		NotificationServiceInstance.SendInformation("Veuillez sélectionner au moins une séquence.");
    	}

    	let oldIndex = 0;
    	if (direction == "haut") {
    		// On replace les séquences
    		// Remonte les séquences d'un index
    		for (let i = 0; i < sequencesABouger.length; i++) {
    			// Quitte si la séquence est la première de la liste
    			if (this.currentLigne.Details.indexOf(sequencesABouger[i]) == 0) {
    				return;
    			}
    			oldIndex = this.currentLigne.Details.indexOf(sequencesABouger[i]);
    			this.currentLigne.Details.splice(oldIndex, 1);
    			this.currentLigne.Details.splice(oldIndex - 1, 0, sequencesABouger[i]);
    		}
    	} else if (direction == "bas") {
    		// On replace les séquences
    		// Redescend les séquences d'un index
    		for (let i = sequencesABouger.length - 1; i >= 0; i--) {
    			// Quitte si la séquence est la dernière de la liste
    			if (this.currentLigne.Details.indexOf(sequencesABouger[i]) == this.currentLigne.Details.length - 1) {
    				return;
    			}
    			oldIndex = this.currentLigne.Details.indexOf(sequencesABouger[i]);
    			this.currentLigne.Details.splice(oldIndex, 1);
    			this.currentLigne.Details.splice(oldIndex + 1, 0, sequencesABouger[i]);
    		}
    	}
	}

	public deleteLines(): void {
    	const sequencesToDelete = this.currentLigne.Details.filter(s => (s as any).selected == true);
    	if (sequencesToDelete.length == 0) {
    		NotificationServiceInstance.SendInformation("Veuillez sélectionner au moins une séquence.");
    	} else {
    		for (let i = 0; i < sequencesToDelete.length; i++) {
    			this.currentLigne.Details.splice(this.currentLigne.Details.indexOf(sequencesToDelete[i]), 1);
    		}
    	}
	}

	public initConstantes(): void {
    	ServicesFactoryInstance.ParametresService.getRegimes(data => {
    		this.listeRegimes = data;
    	});
    	ServicesFactoryInstance.ParametresService.getConventionsCollectives(data => {
    		this.listeConventionCollectives = data;
    	});

    	ServicesFactoryInstance.RubriquesService.getRubriques(data => {
    		this.rubriques = data;
    	});
	}

	public annuler(): void {
		$("#modalUpdateTableau").modal("hide");
	}

	public enregistrer(): boolean | void {
		const errorMessage: string[] = [];
    	if (this.tableau.Code == undefined) {
    		errorMessage.push("Le Code est obligatoire");
    	}
    	if (this.tableau.TitreListe == undefined) {
    		errorMessage.push("Le titre est obligatoire");
    	}

    	if (this.tableau.Id == 0 &&
            this.tableau.CodeTypeTableau == "B" &&
            this.dataModeleLocal == undefined) {
    		errorMessage.push("Vous devez ajouter un document word à votre édition libre");
    	}

    	if (errorMessage.length > 0) {
    		for (let i = 0; i < errorMessage.length; i++) {
    			NotificationServiceInstance.SendFailed(errorMessage[i]);
    		}

    		return false;
        }

        this.tableau.Lignes.forEach((ligne: TableauLigneDto) => {
            ligne.Details.forEach((detail: TableauLigneDetailDto) => {
                const rub = this.getPrioritizedRubrique(detail.CodeRubrique);
                detail.TitreRubrique = rub?.LibelleRubrique;
            });
        });

        this.dataReady = false;
    	if (this.tableau.Id == 0) {
            ServicesFactoryInstance.EditionsService.creerTableau(this.tableau, () => {
                NotificationServiceInstance.SendSuccess("La modification du tableau a été prise en compte");
                this.$emit("EnregistrementCompleted");
                $("#modalUpdateTableau").modal("hide");

                this.gereUploadModele();
            }, () => { this.dataReady = true; });
    	} else {
    		ServicesFactoryInstance.EditionsService.updateTableau(this.tableau, () => {
    			NotificationServiceInstance.SendSuccess("La création du tableau a été prise en compte");
    			this.$emit("EnregistrementCompleted");
    			$("#modalUpdateTableau").modal("hide");

                this.gereUploadModele();
            }, () => { this.dataReady = true; });
    	}
	}

    public checkAddLigne(ligne: TableauLigneDto) {
        if (ligne == undefined || this.tableau == undefined || this.tableau.Lignes == undefined)
            return;

        if (ligne.Id != this.lastId || ligne.NumeroSequence == undefined)
            return;

        if (this.currentLigne.NumeroSequence == ligne.NumeroSequence && this.currentLigne.NumeroSequence == 1789)
            return;

        this.addLigne();
    }

	public addLigne(): void {
    	if (this.tableau.Lignes.filter(l => l.NumeroSequence == undefined).length == 0) {
            this.lastId--;
            this.tableau.Lignes.push({ Id: this.lastId, NumeroSequence: undefined, AutoJournalPaye: false, Details: [] });
    	}
	}

    public addLigneDetail(): void {
        if (this.currentLigne.Details.filter(l => l.CodeRubrique == "").length == 0) {
    		this.currentLigne.Details.push({ CodeRubrique: "", Signe: "+", ConventionCollective: "" });
    		this.$forceUpdate();
    	}
	}

	public setCurrentLigne(ligne: TableauLigneDto): void {
    	this.currentLigne = ligne;
        this.addLigneDetail();
    }

    public getPrioritizedRubrique(codeRubrique: string | undefined): RubriqueDto | undefined {
		return this.rubriques
			.filter(r => r.CodeRubrique == codeRubrique)
			.sort((a, b) => (a.EstArchivee === b.EstArchivee ? 0 : a.EstArchivee ? 1 : -1)) // Trier par non-archivé d'abord
			.sort((a, b) => b.Id - a.Id) // Trier par ID décroissant dans les archivés
			.shift(); // Prendre le premier élément après tri
	}

    public getLibelleRubrique(detail: TableauLigneDetailDto): string {
        const rub = this.getPrioritizedRubrique(detail.CodeRubrique);

        if (rub == null) {
            return detail?.TitreRubrique ?? "";
        }
        if (rub != null) {
            return rub?.LibelleRubrique as string ?? "";
        }
        if (detail.Type == "C" && !isNaN(Number(detail.CodeRubrique))) {
            return "Colonne " + detail.CodeRubrique;
        }

        return "";
    }

	public telecharger(): void {
		NotificationServiceInstance.SendInformation("Téléchargement du modèle en cours");

    	let codeTableau = this.tableau.Code;
    	if (this.codeDuplique != undefined) {
			codeTableau = this.codeDuplique;
		}

    	if (codeTableau == undefined) {
			return;
		}

    	const nomModele = codeTableau.toLowerCase() + ".docx";

    	ServicesFactoryInstance.EditionsService.GetModeleAvecVariablesByCodeTableau(codeTableau, (r: Blob) => {
			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    			window.navigator.msSaveOrOpenBlob(r, nomModele);
    			this.dataReady = true;
    		} else {
    			this.dataReady = true;

    			const link = document.createElement("a");
    			document.body.appendChild(link);

    			link.href = window.URL.createObjectURL(r);
    			link.download = nomModele;
    			link.click();

    			NotificationServiceInstance.SendSuccess(`La récupération du document '${this.tableau.Document}' s'est correctement déroulée !`);
    		}
    	});
	}

    public deposer(event: any): void {
        if (!this.canDeposer) {
            NotificationServiceInstance.SendFailed("Vous n'avez pas les droits pour modifier le modèle du tableau.");
            return;
        }

    	const dataModele = event.target.files[0];
    	if (dataModele != undefined) {
    		let nomModele: string = dataModele.name;
    		nomModele = nomModele.toLowerCase();
    		const extension: string = nomModele.substring(nomModele.length - 5, nomModele.length);
    		if (nomModele.length < 5 || extension != ".docx") {
    			NotificationServiceInstance.SendFailed("Vous devez sélectionner un modèle '.docx'.");
    			this.dataModeleLocal = undefined;
    			this.nomModeleLocal = undefined;
    		} else {
				this.dataModeleLocal = dataModele;
    			this.nomModeleLocal = dataModele.name;
    		}
    	} else {
			this.nomModeleLocal = undefined;
		}

    	this.$forceUpdate();
	}

	public gereUploadModele() {
    	if (this.tableau.CodeTypeTableau != "B" || this.dataModeleLocal == undefined) {
			return;
		}

    	const formData = new FormData();
    	const nomModele = this.tableau.Code + ".docx";

    	formData.append(nomModele, this.dataModeleLocal);

    	ServicesFactoryInstance.EditionsService.UploadModele(formData, () => { });
	}
}




// WEBPACK FOOTER //
// ./src/components/tableaux/modalUpdateTableau/modalUpdateTableau.ts